import { MultiStepPromotionForm, type MultiStepPromotionFormProps } from 'components/Forms';
import { Grid } from 'components/Grid';

interface IMultiStepPromotionForm {
  templateProps: MultiStepPromotionFormProps;
}

export const MultiStepPromotionFormTemplate = ({ templateProps }: IMultiStepPromotionForm) => {
  return (
    <Grid>
      <MultiStepPromotionForm {...templateProps} />
    </Grid>
  );
};
